import { formatMoney } from "./currencyFormat";
export const sideBarData = [
  {
    name: "Dashboard",
    path: "/dashboard",
    image1: "/Images/sidebar/Dashboard.svg",
    image: "/Images/sidebar/Dashboard (1).svg",
    dropDown: "none",
  },
  {
    name: "Cooperatives",
    path: "/cooperatives",
    image: "/Images/sidebar/Loan Management.svg",
    image1: "/Images/sidebar/Loan Management1.svg",
    dropDown: "none",
  },
  {
    name: "Get Started applications",
    path: "/registration-applications",
    image: "/Images/sidebar/Note.svg",
    image1: "/Images/sidebar/Note1.svg",
    dropDown: "none",
  },
  {
    name: "Demo requests",
    path: "/demo-requests",
    image: "/Images/sidebar/Automated Birthday.svg",
    image1: "/Images/sidebar/Automated Birthday1.svg",
    dropDown: "none",
  },
  {
    name: "Contact messages",
    path: "/contact-submissions",
    image: "/Images/sidebar/Call Center.svg",
    image1: "/Images/sidebar/Call Center.svg",
    dropDown: "none",
  },
  {
    name: "Subscriptions",
    path: "/subscriptions",
    image: "/Images/sidebar/Automated Birthday.svg",
    image1: "/Images/sidebar/Automated Birthday1.svg",
    dropDown: "none",
  },
  {
    name: "Transaction history",
    path: "/transaction-history",
    image: "/Images/sidebar/Note.svg",
    image1: "/Images/sidebar/Note1.svg",
    dropDown: "none",
  },
  {
    name: "Settlement & fees",
    path: "/settlement",
    image: "/Images/sidebar/Contribution.svg",
    image1: "/Images/sidebar/Contribution1.svg",
    dropDown: "none",
  },
  {
    name: "Modules",
    path: "/modules",
    image: "/Images/sidebar/Contribution.svg",
    image1: "/Images/sidebar/Contribution1.svg",
    dropDown: "none",
  },

  {
    name: "SMS Messaging",
    path: "/sms-messaging",
    image: "/Images/sidebar/Note.svg",
    image1: "/Images/sidebar/Note1.svg",
    dropDown: "none",
  },
  {
    name: "Support",
    path: "/admin",
    image: "/Images/sidebar/Call Center.svg",
    dropDown: "none",
    disabled: true,
  },
  // {},
];
export const sideBarMemberData = [
  {
    name: "Dashboard",
    path: "/member/dashboard",
    image1: "/Images/sidebar/Dashboard.svg",
    image: "/Images/sidebar/Dashboard (1).svg",
    dropDown: "none",
  },
  {
    name: "Loan Management",
    path: "/member/loan_management",
    image: "/Images/sidebar/Loan Management.svg",
    image1: "/Images/sidebar/Loan Management1.svg",
    dropDown: "none",
    // subMenu:[
    //   {
    //     name:'New Application',
    //     path: "/super_admin/loan_management/new_application",
    //   },
    //   {
    //     name:'Loan Status',
    //     path: "/super_admin/loan_management/loan_status",
    //   },
    //   {
    //     name:'Loan Repayment',
    //     path: "/super_admin/loan_management/loan_repayment",
    //   },
    // ]
  },
  {
    name: "Automated Birthday",
    // path: "/super_admin/automated_birthday",
    image: "/Images/sidebar/Automated Birthday.svg",
    image1: "/Images/sidebar/Automated Birthday1.svg",
    dropDown: "none",
  },
  {
    name: "Contribution",
    path: "/member/contribution",
    image: "/Images/sidebar/Contribution.svg",
    image1: "/Images/sidebar/Contribution1.svg",
    dropDown: "none",
  },

  {
    name: "Attendance",
    path: "/member/attendance",
    image: "/Images/sidebar/Note.svg",
    image1: "/Images/sidebar/Note1.svg",
    dropDown: "none",
  },
  {
    name: "Event Calendar",
    path: "/member/event",
    image: "/Images/sidebar/Calendar.svg",
    image1: "/Images/sidebar/Calendar1.svg",
    dropDown: "none",
  },

  {
    name: "Support",
    // path: "/super_admin/admin",
    image: "/Images/sidebar/Call Center.svg",
    dropDown: "none",
  },

  {
    name: "E-Minutes",
    // path: "/super_admin/admin",
    image: "/Images/sidebar/Timer.svg",
  },
];

export const LoginCarouselData = [
  {
    title: "Collaboration meets Cooperation",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Consectetur nunc, erat auctor commodo eu nunc integer nisl arcu. Nunc tempor sit faucibus nibh. Cursus nec placerat urna elementum suscipit arcu purus, feugiat. Viverra eu lacus enim convallis. Integer in metus eget dolor viverra facilisis enim. Non massa tristique bibendum eu condimentum. Eu ullamcorper nulla sit amet mauris.`,
    image: `/Images/Login/Frame 41.svg`,
  },
  {
    title: "Growth meets Dedication",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Consectetur nunc, erat auctor commodo eu nunc integer nisl arcu. Nunc tempor sit faucibus nibh. Cursus nec placerat urna elementum suscipit arcu purus, feugiat. Viverra eu lacus enim convallis. Integer in metus eget dolor viverra facilisis enim. Non massa tristique bibendum eu condimentum. Eu ullamcorper nulla sit amet mauris.`,

    image: "/Images/Login/Frame 41-1.svg",
  },
  {
    title: "Success meets Determination   ",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Consectetur nunc, erat auctor commodo eu nunc integer nisl arcu. Nunc tempor sit faucibus nibh. Cursus nec placerat urna elementum suscipit arcu purus, feugiat. Viverra eu lacus enim convallis. Integer in metus eget dolor viverra facilisis enim. Non massa tristique bibendum eu condimentum. Eu ullamcorper nulla sit amet mauris.`,
    image: "/Images/Login/Frame 41-2.svg",
  },
];

//delete Later
export const DashboardCards = () => {
  return [
    {
      name: "Onboarded Members",
      total: "400",
      image: "/Images/Dashboard/1.svg",
      percentage: "",
      bgColor: "#A8E1C8",
      color: "#318C64",
    },
    {
      name: "Available Savings",
      total: formatMoney(400 || "0"),
      image: "/Images/Dashboard/2.svg",
      percentage: "",
      bgColor: "#E0A8AE ",
      color: "#8B313A",
    },
    {
      name: "Loan Disbursed",
      total: formatMoney(400 || "0"),
      image: "/Images/Dashboard/1.svg",
      percentage: "",
      bgColor: "#A8D4E1",
      color: "#31778C",
    },
  ];
};

export const ViewMemberCards = () => {
  return [
    {
      name: "Personal savings",
      total: "400",
      image: "/Members/Icon2.svg",
      percentage: "80%",
      bgColor: "#A8E1C8",
      color: "#318C64",
    },
    {
      name: "Contributions",
      total: formatMoney(400 || "0"),
      image: "/Members/Icon2.svg",
      percentage: "80%",
      bgColor: "#E0A8AE ",
      color: "#8B313A",
    },
    {
      name: "Contributions",
      total: formatMoney(400 || "0"),
      image: "/Members/Icon2.svg",
      percentage: "80%",
      bgColor: "#A8D4E1",
      color: "#31778C",
    },
  ];
};
export const ViewMemberDashboardCards = () => {
  return [
    {
      name: "Total Contribution made",
      total: formatMoney(400 || "0"),
      image: "/MemberSide/Icons/dashboard1.svg",
      percentage: "80%",
      bgColor: "#A8E1C8",
      color: "#318C64",
    },
    {
      name: "Loan Balance",
      total: formatMoney(400 || "0"),
      image: "/MemberSide/Icons/dashboard2.svg",
      percentage: "80%",
      bgColor: "#E0A8AE ",
      color: "#8B313A",
    },
  ];
};

export const ColorList = [
  "#8B313A",
  " #31778C",
  "#318C64",
  "#383838",
  "#6C63FF",
  "#384FFF",
  "#FF4539",
  "#DD3629",
  "#BDA9EE",
  "#FFB9B9",
  "#EB9612",
  "#318C64",
];
